import React from 'react';

import IconVimeo from 'components/atoms/iconVimeo';
import IconInstagram from 'components/atoms/iconInstagram';
import IconContentful from 'components/atoms/iconContentful';

import './style.css';

const Footer = props => {
    return (
        <div className="Footer">
            <div className="Footer__contents">
                <div className="Footer__copyright">
                    <div className="Copyright">© Kurt Riddell 2018</div>
                </div>
                <div className="Footer__quick-contact">
                    <div className="QuickContact">
                        <a
                            className="QuickContact__email"
                            href="mailto:kurt@kurtriddell.com"
                        >
                            kurt@kurtriddell.com
                        </a>
                        <br />
                        <a
                            className="QuickContact__tel"
                            href="tel:+44 (0)7518 669 374"
                        >
                            +44 (0)7518 669 374
                        </a>
                    </div>
                </div>
                <div className="Footer__links">
                    <div className="Social">
                        <a
                            className="Social__vimeo"
                            href="https://vimeo.com/kurtriddell"
                        >
                            <IconVimeo />
                        </a>
                        <a
                            className="Social__instagram"
                            href="https://www.instagram.com/kurtriddell__/"
                        >
                            <IconInstagram />
                        </a>
                    </div>
                </div>
                <div className="Footer__attribution">
                    <div className="ContentfulAttribution">
                        <a
                            className="ContentfulAttribution__link"
                            href="https://www.contentful.com/"
                            rel="noopener noreferrer nofollow"
                            target="_blank"
                        >
                            <IconContentful />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/organisms/app/footer/index.js